export default function formatMoney(money) {
	return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(money);
}
